import KeyValuePair from '@/modules/core/support/KeyValuePair';
import Message from '@/modules/i18n/model/Message';

export default class MessagePagination {

    public constructor (
        public messages: Message[] = [],
        public totalPages = 0,
        public totalRecords = 0,
        public recordsPerPage = 0,
    ) {}

    public static deserialize (data: KeyValuePair): MessagePagination {
        return new this(
            data.messages.map((m: KeyValuePair) => Message.convert(m)),
            data.total_pages,
            data.total_records,
            data.records_per_page,
        )
    }
}
